import React, { useRef, useState, useContext, useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import "./menuPopUpSearchFilter.css"
import { MenuAccordionSearchFilter } from './menuAccordionSearchFilter';
import { FilterSwipeDialog } from '../../../components/dialog/FilterSwipeDialog';
import RechercheContext from '../RechercheContext';

export const MenuPopUpSearchFilter = (props) => {
    const { t } = useTranslation();
    const contextRecherche = useContext(RechercheContext);

    return (
        <FilterSwipeDialog
            isLoading={props.isLoading}
            onClearFilters={props.handleClicEffacerFiltres}
            className="mpsf-dialog"
        >
            <MenuAccordionSearchFilter 
                activeIndex={props.activeIndex} 
                setActiveIndex={props.setActiveIndex} 
                isInFavoris={props.isInFavoris} 
            />
        </FilterSwipeDialog>
    )
}